export default __webpack_public_path__ + "static/media/andean2.6ec7ca47.jpg";